import React from "react";
import "./about.css";
import SocialContact from "../../../Common/Social-Contact";
import Typewriter from "typewriter-effect";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCloudArrowDown, faEnvelope} from "@fortawesome/free-solid-svg-icons";
import {faGithubSquare, faLinkedin} from "@fortawesome/free-brands-svg-icons";

function About() {
  return (
    <div className="about">
      <div className="about-top">
        <div className="about-info">
          Hello There, 👋 my name is
          <br /> <span className="info-name">Prince Kumar </span> <br />
          <h4>
              I'm a
            <span className="typewriter">
              <Typewriter
                options={{
                  strings: ["Freelancer", "Full-Stack Developer"],
                  autoStart: true,
                  loop: true,
                }}
              />
            </span>
          </h4>
          <div className="social-icon">
            <a href="https://www.linkedin.com/in/prince-kumar-3451a11ba">
          <FontAwesomeIcon icon={faLinkedin} size="2xl" style={{color: "#0a66c2",}} />
          </a>
          <a href="https://github.com/prince-111">
          <FontAwesomeIcon icon={faGithubSquare} size="2xl" style={{color: "#000000",}} />
          </a>
          <a href="mailto: princesd991@gmail.com">
          <FontAwesomeIcon icon={faEnvelope} size="2xl" style={{color: "#3e65cf",}} />
          </a>
          </div>
          
          {/* <SocialContact /> */}
          <div className="download">
            <a download href={require("../../../assets/resume.pdf")}>
            <FontAwesomeIcon icon={faCloudArrowDown} beat /> Download Resume
            </a>
          </div>
        </div>
        <div className="about-photo">
          <img
            // src={require("../../../assets/Programming.gif")}
            src={require("../../../assets/Programming-bro.png")}
            className="picture"
            alt=""
          />
          {/* book, pen, laptop, marker, copy keyword  */}
        </div>
      </div>
    </div>
  );
}

export default About;
